import React from 'react';
import "./scraping.css";
import NavBar from '../NavBar';
import Footer from '../Footer';

function ScrapingI(props) {
  return (
    <div className='scraping-container'>
      <div className='header-shadow'></div>
      <NavBar/>
        <iframe src="scraping.html" style={{width: "100%", border: "none", minHeight: "calc(100vh - 6em)", marginTop: "8em"}}></iframe>
      {/* <Footer/> */}
    </div>
  );
}

export default ScrapingI;
